import React, { useEffect, useState } from 'react'
import { __set, __remove } from "src/store/axios_indicator";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';

const QuoteCheckoutShipping = () => {
    const [__check] = useAxiosIndicatorCheck();
    const {
        mobilePattern,
        paymentError,
        checkOutSteps: { ADDRESS_STEP, METHOD_STEP },
        taxExempt: { NONE }, } = Constants
    const { storageName: { PAYMENT_ERROR } } = System

    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ countryList }, { get_country_list, get_state_list, fetch_all_carrier_data }] = profileStore();

    const [isEdit, setIsEdit] = useState(false);
    const [errors, setErrors] = useState({});

    const [, setCheckoutStepStatus] = useReduxState(ADDRESS_STEP, 'setCheckoutStepStatus')
    const [taxExemptDetails] = useReduxState({ taxExemptFile: '', taxExempt: NONE }, "setTaxExemptDetails");
    const [quoteHeaderData, setQuoteHeaderData] = useReduxState({}, 'setQuoteHeaderData')
    const [quoteList] = useReduxState({}, 'QuoteCartList')
    const [checkoutData, setCheckoutData] = useReduxState('', 'setCheckoutData')

    useEffect(() => {
        async function fetchHere() {
            await get_country_list();
        }
        if (countryList?.length <= 0 && quoteHeaderData?.shipToAddress?.length) {
            fetchHere()
        }

        validateHazardousItemInCart()
    }, [quoteHeaderData]);

    const getCountryName = (country) => {
        return countryList.find(ele => ele.countryCode === country)?.countryName
    }

    const getStateName = async (country, stateCode) => {
        if (stateCode === 'IC') return stateCode;
        if (!country || !stateCode) return '';

        const states = await get_state_list(country);
        return states.find(ele => ele.stateCode === stateCode)?.stateName || '';
    }

    useEffect(() => {
        const shipTo = quoteHeaderData?.shipToAddress?.length ? quoteHeaderData?.shipToAddress[0] : {}
        const billTo = quoteHeaderData?.soldToAddress?.length ? quoteHeaderData?.soldToAddress[0] : {}

        const setShippingData = async () => {
            const stateData = shipTo?.country === billTo?.country
                && await getStateName(shipTo?.country, shipTo?.state)

            const newShipTo = [...quoteHeaderData.shipToAddress];
            newShipTo[0] = {
                ...shipTo,
                countryName: getCountryName(shipTo?.country),
                stateName: stateData ? stateData : await getStateName(shipTo?.country, shipTo?.state)
            };

            const newBillTo = [...quoteHeaderData.soldToAddress];
            newBillTo[0] = {
                ...billTo,
                countryName: getCountryName(billTo?.country),
                stateName: stateData ? stateData : await getStateName(billTo?.country, billTo?.state)
            };

            setQuoteHeaderData({ ...quoteHeaderData, shipToAddress: newShipTo, soldToAddress: newBillTo })
        }

        if (countryList?.length && quoteHeaderData?.shipToAddress?.length && quoteHeaderData?.soldToAddress?.length &&
            (!shipTo?.countryName || !billTo?.countryName) &&
            (!shipTo?.stateName || !billTo?.stateName)) {
            setShippingData()
        }
    }, [countryList, quoteHeaderData])

    useEffect(() => {
        if (new URL(window.location.href)?.searchParams.has(paymentError)) {
            system_alert_indicator({
                name: 'placeOrderError',
                message: localStorage.getItem(PAYMENT_ERROR),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        } else {
            localStorage.removeItem(PAYMENT_ERROR)
        }
    }, [])

    const validateHazardousItemInCart = () => {
        if (quoteList && quoteList?.length > 0) {
            const ishazardious = quoteList.find(f => f?.HazardousFlag === true)
            if (ishazardious) {
                system_alert_indicator({
                    name: 'HazardousFlag',
                    message: "Hazardous Item: Due to restrictions on the transportation of dangerous/hazardous goods, there may be additional transit time on this item. Delivery of other items on your order will be unaffected.",
                    type: "warning",
                    isDisplay: false,
                    isDisplayIcon: true
                });
            }
        }
    }

    const onValidateData = () => {
        let validationModal = {};
        if (checkoutData?.telephoneNumber && !mobilePattern.test(checkoutData.telephoneNumber)) {
            validationModal.telephoneNumber = "A valid phone number is required.";
        }
        setErrors(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    const onSubmit = async () => {
        let isValid = await onValidateData();
        if (isValid) {
            let params = {
                shipToAddress: quoteHeaderData?.shipToAddress[0],
                soldToAddress: quoteHeaderData?.soldToAddress[0],
                attn: checkoutData?.attn?.trim() ? checkoutData?.attn?.trim() : '',
                telephoneNumber: checkoutData?.telephoneNumber?.trim() ? checkoutData?.telephoneNumber?.trim() : '',
                taxExempt: taxExemptDetails?.taxExempt,
                shipToId: quoteHeaderData?.shipToAccountNo,
                billTo: quoteHeaderData?.soldToCustomerAccountNo,
                wholeDelivery: true,
                orderPlaced: true,
                orderBlock: false,
                creditRisk: false,
                pecEmail: null,
                sdiNumber: null,
                sapQuoteNumber: null,
                softwareDownloadEmail: null,
            }

            setCheckoutData({ ...checkoutData, ...params })
            setIsEdit(true);

            //fetch carrier options
            __set('CARRIER_OPTION_UPDATE');
            await fetch_all_carrier_data({
                orderId: null,
                country: quoteHeaderData?.shipToAddress[0]?.countryName,
                shipToId: null,
                isFromQuoteCheckout: true
            });
            __remove('CARRIER_OPTION_UPDATE');
            setCheckoutStepStatus(METHOD_STEP)
        }
    }

    return (
        <div className={`shipping-address steps-inner mb-3 active ${isEdit ? ' completed' : ''}`}>
            <div className="checkout-titles d-flex justify-content-between"><h2>1. Shipping Address </h2> {isEdit && <a className='text-white' onClick={() => {
                setIsEdit(false);
                remove_system_alert_indicator('carrierOptionAlert');
                setCheckoutStepStatus(ADDRESS_STEP)
            }} >Change </a>}</div>
            <div className='shipping-address-detail checkbox-steps-content pt-0 pb-0'>
                <div className='bs5 row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-2 pb-2'>
                        <div>
                            <div className='d-flex justify-content-between'>
                                {quoteHeaderData?.shipToAddress?.length > 0 && <div>
                                    <div className="font-16 font-bold font-apecru mb-2">{quoteHeaderData?.shipToCustomerName} </div>
                                    <p className='font-arial font-13'>
                                        {quoteHeaderData?.shipToAddress[0]?.address1stLine && quoteHeaderData?.shipToAddress[0]?.address1stLine + ","}
                                        <br /> {Helper.valueIsNotNull(quoteHeaderData?.shipToAddress[0]?.addressLineTwo) ?
                                            <> {quoteHeaderData?.shipToAddress[0]?.addressLineTwo + ","}<br /></> : ""}
                                        {quoteHeaderData?.shipToAddress[0]?.city && quoteHeaderData?.shipToAddress[0]?.city + ","} {Helper.valueIsNotNull(quoteHeaderData?.shipToAddress[0]?.stateName)
                                            ? quoteHeaderData?.shipToAddress[0]?.stateName + " " : ""} {quoteHeaderData?.shipToAddress[0]?.zipCode && quoteHeaderData?.shipToAddress[0]?.zipCode + ","}
                                        <br /> {quoteHeaderData?.shipToAddress[0]?.countryName && quoteHeaderData?.shipToAddress[0]?.countryName + "."}
                                    </p></div>}
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className='shipping-additional-info step-complete-hide info-text'>
                            <div className='form'>
                                <div className='mb-2'>Information used in case of order or shipping issues.</div>
                                <div className="mb-3">
                                    <label htmlFor="attn" className="form-label">ATTN</label>

                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className={`form-control ${errors.attn ? 'error' : ''}`}
                                        id="attn"
                                        placeholder="Attention"
                                        value={checkoutData?.attn || ''}
                                        onChange={({ target: { value } }) => setCheckoutData({ ...checkoutData, attn: value })}
                                    />
                                    {errors.attn && <p className="error">{errors.attn}</p>}
                                </div>
                                <div className="mb-3"><label htmlFor="ph-no" className="form-label">Phone Number</label>

                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className={`form-control ${errors.telephoneNumber ? 'error' : ''}`}
                                        id="phone"
                                        placeholder="Phone number"
                                        value={checkoutData?.telephoneNumber || ''}
                                        onChange={({ target: { value } }) => setCheckoutData({ ...checkoutData, telephoneNumber: value })}
                                        maxLength={32}
                                    />
                                    {errors.telephoneNumber && <p className="error">{errors.telephoneNumber}</p>}</div>
                            </div>
                        </div>

                        {(checkoutData?.attn || checkoutData?.telephoneNumber) && <div className="step-complete-show h-100">
                            <div className="info-text h-100">
                                {checkoutData?.attn && <p className="mb-2">ATTN: {checkoutData?.attn}</p>}
                                {checkoutData?.telephoneNumber && <p className="mb-2">Phone Number: {checkoutData?.telephoneNumber}</p>}
                            </div>
                        </div>}
                    </div>
                </div>
                <hr className="mb-0 mt-0 step-complete-hide"></hr>
            </div>
            <div className='shipping-method-detail checkbox-steps-content pt-0 step-complete-hide'>
                <div className='bs5 row'>
                    <div className='col-12 col-sm-12 col-lg-6 col-xl-6'></div>

                    <div className='col-12 col-sm-12 col-lg-6 col-xl-6 d-flex align-items-start flex-wrap'>
                        {!isEdit && <button
                            type="button" className="bs5 btn btn-primary btn-sm mt-3 d-block ms-auto w100"
                            onClick={() => onSubmit()}
                            form="hook-form">Continue</button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuoteCheckoutShipping;